import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const iconSpotWrapper = css`
  padding: ${spacing(1)};
  border-radius: ${spacing(1.5)};
  background-color: ${cssTheme.colors.warmGray[100].hex};
`
